import { useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { Input, Button, Typography, Card, Form, Alert, message } from "antd";
import { MailOutlined } from "@ant-design/icons";
import { resetPassword as resetPasswordAPI } from "../../api/user";

const ResetPassword = () => {
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const [errorMessage, setErrorMessage] = useState("");
    const { Text, Title, Link } = Typography;
    const [submitting, setSubmitting] = useState(false);
    const [userId, setUserId] = useState(null);
    const [resetToken, setResetToken] = useState(null);

    useEffect(() => {  
        try {
            const searchParams = new URLSearchParams(window.location.search);  
            const id = searchParams.get('id');  
            const token = searchParams.get('token');  
    
            if (id && token) {  
                setUserId(id);  
                setResetToken(token);  
                const newUrl = window.location.origin + window.location.pathname;  
                window.history.replaceState({}, document.title, newUrl);  
            }  
        } catch (error) {
            message.error("There was an issue getting your user information");
        }
        
    }, []);  

    const formData = {
        password: "",
        confirm_password: ""
    };

    const resetPassword = async (values) => {
        try {
            const asd = await resetPasswordAPI(userId, resetToken, values.password);
        } catch (error) {
            message.error('There was an issue resetting your password');
        } finally {
            message.success('Your password has been reset');
            navigate('/', { replace: true });
        }
    }

    return (
        <div className="frontend-form">
        <div className='frontend-form-graphic' style={{ backgroundImage: 'url("/images/SACOPAPortalBackground.svg")' }}></div>
            <Card className="frontend-form-container">
                <Title level={3}>Password Reset</Title>
                <Text type="secondary">Please fill out the form below to reset your password.</Text>
                <div className="steps-content">
                    <Form layout='vertical' form={form} onFinish={resetPassword}>
                        {Object.keys(formData).map((key) => (
                            key !== "confirm_password" ? (
                                <Form.Item key={key} rules={[{ required: true }]} required name={key} label={key.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase())}>
                                    <Input
                                        type={key === "password" ? "password" : "text"}
                                        placeholder={key.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase())}
                                        autoComplete="off"
                                    />
                                </Form.Item>
                            ) : null
                        ))}
                        <Form.Item  
                            name="confirm_password"  
                            label="Confirm Password"  
                            rules={[  
                                { required: true, message: 'Please confirm your password!' },  
                                ({ getFieldValue }) => ({  
                                    validator(_, value) {  
                                        if (!value || getFieldValue('password') === value) {  
                                            return Promise.resolve();  
                                        }  
                                        return Promise.reject(new Error('The two passwords do not match!'));  
                                    },  
                                }),  
                            ]}  
                        >  
                            <Input.Password placeholder="Confirm Password" autoComplete="off" />  
                        </Form.Item>
                        {errorMessage && <Form.Item><Alert type="error" message={errorMessage} /></Form.Item>}
                        <Form.Item>
                            <Button type="primary" htmlType="submit" icon={<MailOutlined />} loading={submitting}>Reset Password</Button>
                        </Form.Item>
                    </Form>
                </div>
            </Card>
        </div>
    );
};

export default ResetPassword;  
